export default __webpack_public_path__ + "static/media/Neck_Pain.d4b84b97.webp";